import {
	CaretRightOutlined,
	HomeOutlined,
	MenuUnfoldOutlined,
	OrderedListOutlined,
	UnorderedListOutlined,
	UsergroupAddOutlined,
	UserOutlined,
} from '@ant-design/icons'
import { Menu, MenuProps } from 'antd'
import Sider from 'antd/es/layout/Sider'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import { Paths } from '../../paths'
import { useTranslation } from 'react-i18next'

type MenuItem = Required<MenuProps>['items'][number] & {
	role?: string[]
	children?: MenuItem[]
}

type Props = {
	collapsed: boolean
}

export const Sidebar = ({ collapsed }: Props) => {
	const location = useLocation()
	const navigate = useNavigate()
	const { t } = useTranslation()

	const storedData = JSON.parse(localStorage.getItem('availableRoutes') || 'null')

	const Logo = styled.div`
      height: 32px;
      margin: 16px;
      background: #fff;
      border-radius: 6px;
      font-size: 22px;
      line-height: 1;
      text-align: center;
      font-weight: 700;
      color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      border: 1px solid;
      border-image-source: linear-gradient(
              90deg,
              rgba(224, 225, 226, 0) 0%,
              #e0e1e2 49.52%,
              rgba(224, 225, 226, 0.15625) 99.04%
      );
  `

	const MenuLink = styled(Link)`
      font-size: 14px !important;
  `

	const getSelectedKeys = () => {
		return [location.pathname]
	}

	const getDefaultOpenKeys = () => {
		const parentKeys = [Paths.handbooks.index]
		return parentKeys.filter(key => location.pathname.startsWith(key))
	}

	const menuItems: MenuItem[] = [
		{
			key: Paths.home,
			icon: (
				<Link className='nopaddingicon' to={Paths.home}>
					<HomeOutlined />
				</Link>
			),
			label: <MenuLink to={Paths.home}>{t('general.main')}</MenuLink>,
			title: t('general.main'),
		},
		{
			key: Paths.roles,
			icon: (
				<Link className='nopaddingicon' to={Paths.roles}>
					<UserOutlined />
				</Link>
			),
			label: <MenuLink to={Paths.roles}>{t('titles.roles')}</MenuLink>,
			title: t('titles.roles'),
		},

		{
			key: Paths.users,
			icon: (
				<Link className='nopaddingicon' to={Paths.users}>
					<UsergroupAddOutlined />
				</Link>
			),
			label: <MenuLink to={Paths.users}>{t('titles.users')}</MenuLink>,
			title: t('titles.users'),
		},
		{
			key: Paths.kurultairegister,
			icon: (
				<Link className='nopaddingicon' to={Paths.kurultairegister}>
					<MenuUnfoldOutlined />
				</Link>
			),
			label: <MenuLink to={Paths.kurultairegister}>{t('titles.kurultai')}</MenuLink>,
			title: t('titles.kurultai'),
		},
		{
			key: 'general',
			icon: <OrderedListOutlined />,
			label: <>{t('common_block')}</>,
			children: [
				{
					key: Paths.registries.financialindicators,
					icon: (
						<Link className='nopaddingicon' to={Paths.registries.financialindicators}>
							<MenuUnfoldOutlined />
						</Link>
					),
					label: (
						<MenuLink to={Paths.registries.financialindicators}>
							{t('titles.financial_indicators')}
						</MenuLink>
					),
					title: t('titles.financial_indicators'),
				},
				{
					key: Paths.registries.personel,
					icon: (
						<Link className='nopaddingicon' to={Paths.registries.personel}>
							<MenuUnfoldOutlined />
						</Link>
					),
					label: <MenuLink to={Paths.registries.personel}>{t('titles.personnel')}</MenuLink>,
					title: t('titles.personnel'),
				},
				{
					key: Paths.registries.realestateregister,
					icon: (
						<Link className='nopaddingicon' to={Paths.registries.realestateregister}>
							<MenuUnfoldOutlined />
						</Link>
					),
					label: <MenuLink to={Paths.registries.realestateregister}>{t('titles.realty')}</MenuLink>,
					title: t('titles.realty'),
				},
				{
					key: Paths.registries.movableProperty,
					icon: (
						<Link className='nopaddingicon' to={Paths.registries.movableProperty}>
							<MenuUnfoldOutlined />
						</Link>
					),
					label: (
						<MenuLink to={Paths.registries.movableProperty}>
							{t('titles.movable_property')}
						</MenuLink>
					),
					title: t('titles.movable_property'),
				},

				// {
				//     key: Paths.farmowners,
				//     icon: <Link className='nopaddingicon' to={Paths.farmowners}><MenuUnfoldOutlined /></Link>,
				//     label: <MenuLink to={Paths.farmowners}>{t('titles.register_of_farmowners')}</MenuLink>,
				//     title: `${t('titles.register_of_farmowners')}`
				// },
				// {
				//     key: Paths.breedingfarms,
				//     icon: <Link className='nopaddingicon' to={Paths.breedingfarms}><MenuUnfoldOutlined /></Link>,
				//     label: <MenuLink to={Paths.breedingfarms}>{t('titles.register_of_breefingfaerm')}</MenuLink>,
				//     title: `${t('titles.register_of_breefingfaerm')}`
				// },
				// {
				//     key: Paths.populations,
				//     icon: <Link className='nopaddingicon' to={Paths.populations}><MenuUnfoldOutlined /></Link>,
				//     label: <MenuLink to={Paths.populations}>{t('titles.register_of_population')}</MenuLink>,
				//     title: `${t('titles.register_of_population')}`
				// },
				// {
				//     key: Paths.products,
				//     icon: <Link className='nopaddingicon' to={Paths.products}><MenuUnfoldOutlined /></Link>,
				//     label: <MenuLink to={Paths.products}>
				//         {t('titles.register_of_productions')}
				//     </MenuLink>,
				//     title: `${t('titles.register_of_productions')}`
				// },
			],
		},
		{
			key: 'reservoirs',
			icon: <OrderedListOutlined />,
			label: <>{t('Водные ресурсы')}</>,
			children: [
				{
					key: Paths.reservoirs,
					icon: (
						<Link className='nopaddingicon' to={Paths.reservoirs}>
							<MenuUnfoldOutlined />
						</Link>
					),
					label: <MenuLink to={Paths.reservoirs}>{t('titles.register_of_reservoirs')}</MenuLink>,
					title: `${t('titles.register_of_reservoirs')}`,
				},
				{
					key: Paths.reservoirshistory,
					icon: (
						<Link className='nopaddingicon' to={Paths.reservoirshistory}>
							<MenuUnfoldOutlined />
						</Link>
					),
					label: (
						<MenuLink to={Paths.reservoirshistory}>
							{t('titles.register_of_hostory_reservoirs')}
						</MenuLink>
					),
					title: t('titles.register_of_hostory_reservoirs'),
				},
			],
		},
		{
			key: Paths.mechanization.info,
			className: 'mechanization-link',
			icon: <OrderedListOutlined />,
			label: <>{t('titles.mechanization')}</>,
			title: t('titles.mechanization'),
			onClick: () => navigate(Paths.mechanization.info),
		},
		{
			key: 'chemicalization_wrapper',
			icon: <OrderedListOutlined />,
			label: <>{t('titles.chemicalization')}</>,
			children: [
				{
					key: 'chemicalization_company',
					icon: <UnorderedListOutlined />,
					label: <>{t('titles.company')}</>,
					children: [
						{
							key: Paths.chemicalization.company,
							icon: (
								<Link className='nopaddingicon' to={Paths.chemicalization.company}>
									<CaretRightOutlined />
								</Link>
							),
							label: <MenuLink to={Paths.chemicalization.company}>{t('titles.company')}</MenuLink>,
							title: t('titles.company'),
						},
						{
							key: Paths.chemicalization.company_warehouses,
							icon: (
								<Link className='nopaddingicon' to={Paths.chemicalization.company_warehouses}>
									<CaretRightOutlined />
								</Link>
							),
							label: (
								<MenuLink to={Paths.chemicalization.company_warehouses}>
									{t('titles.company_warehouses')}
								</MenuLink>
							),
							title: t('titles.company_warehouses'),
						},
						{
							key: Paths.chemicalization.stock,
							icon: (
								<Link className='nopaddingicon' to={Paths.chemicalization.stock}>
									<CaretRightOutlined />
								</Link>
							),
							label: <MenuLink to={Paths.chemicalization.stock}>{t('titles.stock')}</MenuLink>,
							title: t('titles.stock'),
						},
					],
				},
				{
					key: Paths.chemicalization.register_of_pesticides,
					icon: (
						<Link className='nopaddingicon' to={Paths.chemicalization.register_of_pesticides}>
							<MenuUnfoldOutlined />
						</Link>
					),
					label: (
						<MenuLink to={Paths.chemicalization.register_of_pesticides}>
							{t('titles.register_of_pesticides')}
						</MenuLink>
					),
					title: t('titles.register_of_pesticides'),
				},
				{
					key: Paths.chemicalization.fertilizer_usage,
					icon: (
						<Link className='nopaddingicon' to={Paths.chemicalization.fertilizer_usage}>
							<MenuUnfoldOutlined />
						</Link>
					),
					label: (
						<MenuLink to={Paths.chemicalization.fertilizer_usage}>
							{t('titles.fertilizer_usage')}
						</MenuLink>
					),
					title: t('titles.fertilizer_usage'),
				},
				{
					key: Paths.chemicalization.winterCerealFertilizer,
					icon: (
						<Link className='nopaddingicon' to={Paths.chemicalization.winterCerealFertilizer}>
							<MenuUnfoldOutlined />
						</Link>
					),
					label: (
						<MenuLink to={Paths.chemicalization.winterCerealFertilizer}>
							{t('titles.winter_cereal_fertilizer')}
						</MenuLink>
					),
					title: t('titles.winter_cereal_fertilizer'),
				},

				// {
				//   key: Paths.chemicalization.fertilizer_sypply,
				//   icon: <Link className='nopaddingicon'
				// 			  to={ Paths.chemicalization.fertilizer_sypply }><MenuUnfoldOutlined/></Link>,
				//   label: <MenuLink to={ Paths.chemicalization.fertilizer_sypply }>
				// 	{ t('chemicalization.fertilizer_sypply') }
				//
				//   </MenuLink>,
				//   title: t('chemicalization.fertilizer_sypply')
				// },
				// {
				//   key: Paths.chemicalization.fertilizer_needs,
				//   icon: <Link className='nopaddingicon'
				// 			  to={ Paths.chemicalization.fertilizer_needs }><MenuUnfoldOutlined/></Link>,
				//   label: <MenuLink to={ Paths.chemicalization.fertilizer_needs }>
				// 	{ t('chemicalization.fertilizer_needs') }
				//
				//   </MenuLink>,
				//   title: t('chemicalization.fertilizer_needs')
				// },
				// {
				//   key: Paths.chemicalization.fertiliser,
				//   icon: <Link className='nopaddingicon' to={ Paths.chemicalization.fertiliser }><MenuUnfoldOutlined/></Link>,
				//   label: <MenuLink to={ Paths.chemicalization.fertiliser }>
				// 	{ t('chemicalization.fertiliser') }
				//
				//   </MenuLink>,
				//   title: t('chemicalization.fertiliser')
				// },
			],
		},
		{
			key: 'dpoa',
			icon: <OrderedListOutlined />,
			label: <>{t('ДППиОСХ')}</>,
			children: [
				{
					key: Paths.organic.grossproductioncooperative,
					icon: <CaretRightOutlined />,
					label: (
						<MenuLink to={Paths.organic.grossproductioncooperative}>
							{t('Валовый сбор продукции')}
						</MenuLink>
					),
					title: t('Валовый сбор продукции'),
				},
				{
					key: Paths.organic.processingCapacity,
					icon: <CaretRightOutlined />,
					label: (
						<MenuLink to={Paths.organic.processingCapacity}>
							{t('Мощности переработки')}
						</MenuLink>
					),
					title: t('Мощности переработки'),
				},
				{
					key: Paths.organic.theNeedsOfthePopulation,
					icon: <CaretRightOutlined />,
					label: (
						<MenuLink to={Paths.organic.theNeedsOfthePopulation}>
							{t('Потребности населения')}
						</MenuLink>
					),
					title: t('Потребности населения'),
				},
				{
					key: Paths.organic.livestockTradeActivity,
					icon: <CaretRightOutlined />,
					label: (
						<MenuLink to={Paths.organic.livestockTradeActivity}>
							{t('Внешняя и взаимная торговля')}
						</MenuLink>
					),
					title: t('Внешняя и взаимная торговля'),
				},
				{
					key: Paths.organic.animalRegister,
					icon: <CaretRightOutlined />,
					label: (
						<MenuLink to={Paths.organic.animalRegister}>
							{t('Учет наличия скота и птицы')}
						</MenuLink>
					),
					title: t('Учет наличия скота и птицы'),
				},
				{
					key: Paths.organic.tradeRegistry,
					icon: <CaretRightOutlined />,
					label: (
						<MenuLink to={Paths.organic.tradeRegistry}>
							{t('Экспорт/импорт')}
						</MenuLink>
					),
					title: t('Экспорт/импорт'),
				},
				{
					key: Paths.organic.storage,
					icon: <CaretRightOutlined />,
					label: (
						<MenuLink to={Paths.organic.storage}>
							{t('Хранилища')}
						</MenuLink>
					),
					title: t('Хранилища'),
				},
				{
					key: Paths.organic.logisticsCenter,
					icon: <CaretRightOutlined />,
					label: (
						<MenuLink to={Paths.organic.logisticsCenter}>
							{t('ТЛЦ')}
						</MenuLink>
					),
					title: t('ТЛЦ'),
				},
				{
					key: Paths.organic.processingCompaniesadmin,
					icon: <CaretRightOutlined />,
					label: (
						<MenuLink to={Paths.organic.processingCompaniesadmin}>
							{t('Перерабатывающие компании')}
						</MenuLink>
					),
					title: t('Перерабатывающие компании'),
				},
				{
					key: Paths.organic.organicproducers,
					icon: <CaretRightOutlined />,
					label: (
						<MenuLink to={Paths.organic.organicproducers}>
							{t('Органические производители')}
						</MenuLink>
					),
					title: t('Органические производители'),
				},
			],
		},
		{
			key: Paths.handbooks.index,
			icon: <UnorderedListOutlined />,
			label: <>{t('titles.handbook')}</>,
			children: [
				{
					key: Paths.handbooks.mechanization,
					icon: <UnorderedListOutlined />,
					label: <>{t('titles.mechanization')}</>,
					children: [
						{
							key: Paths.handbooks.economicactivitytypes,
							icon: <CaretRightOutlined />,
							label: (
								<MenuLink to={Paths.handbooks.economicactivitytypes}>
									{t('titles.directory_economic_activities')}
								</MenuLink>
							),
							title: t('titles.directory_economic_activities'),
						},
						{
							key: Paths.handbooks.leasingoperator,
							icon: <CaretRightOutlined />,
							label: (
								<MenuLink to={Paths.handbooks.leasingoperator}>
									{t('titles.leasing_operator')}
								</MenuLink>
							),
							title: t('titles.leasing_operator'),
						},
						{
							key: Paths.handbooks.entitytypes,
							icon: <CaretRightOutlined />,
							label: (
								<MenuLink to={Paths.handbooks.entitytypes}>
									{t('titles.organizational_and_legal_forms')}
								</MenuLink>
							),
							title: t('titles.organizational_and_legal_forms'),
						},
						{
							key: Paths.handbooks.leasingproject,
							icon: <CaretRightOutlined />,
							label: (
								<MenuLink to={Paths.handbooks.leasingproject}>{t('leasing_project')}</MenuLink>
							),
							title: t('leasing_project'),
						},
					],
				},
				{
					key: Paths.handbooks.transport,
					icon: <UnorderedListOutlined />,
					label: <>{t('titles.transport')}</>,
					children: [
						{
							key: Paths.handbooks.typetransport,
							icon: <CaretRightOutlined />,
							label: (
								<MenuLink to={Paths.handbooks.typetransport}>{t('titles.type_transport')}</MenuLink>
							),
							title: t('titles.type_transport'),
						},
						{
							key: Paths.handbooks.transportcategory,
							icon: <CaretRightOutlined />,
							label: (
								<MenuLink to={Paths.handbooks.transportcategory}>
									{t('titles.transport_category')}
								</MenuLink>
							),
							title: t('titles.transport_category'),
						},
						{
							key: Paths.handbooks.transportstatus,
							icon: <CaretRightOutlined />,
							label: (
								<MenuLink to={Paths.handbooks.transportstatus}>
									{t('titles.transport_status')}
								</MenuLink>
							),
							title: t('titles.transport_status'),
						},
					],
				},
				{
					key: Paths.handbooks.kurultai,
					icon: <UnorderedListOutlined />,
					label: <>{t('titles.kurultai')}</>,
					children: [
						{
							key: Paths.handbooks.questionCategoryType,
							icon: <CaretRightOutlined />,
							label: (
								<MenuLink to={Paths.handbooks.questionCategoryType}>
									{t('titles.question_category_type')}
								</MenuLink>
							),
							title: t('titles.question_category_type'),
						},
						{
							key: Paths.handbooks.executionStatusType,
							icon: <CaretRightOutlined />,
							label: (
								<MenuLink to={Paths.handbooks.executionStatusType}>
									{t('titles.completion_status_type')}
								</MenuLink>
							),
							title: t('titles.completion_status_type'),
						},
					],
				},
				{
					key: Paths.handbooks.farming,
					icon: <UnorderedListOutlined />,
					label: <>{t('titles.farming')}</>,
					children: [
						{
							key: Paths.handbooks.breedingFarmStatuses,
							icon: <CaretRightOutlined />,
							label: (
								<MenuLink to={Paths.handbooks.breedingFarmStatuses}>
									{t('titles.phiv_statuses')}
								</MenuLink>
							),
							title: t('titles.phiv_statuses'),
						},
						{
							key: Paths.handbooks.animalbreedfarmtypes,
							icon: <CaretRightOutlined />,
							label: (
								<MenuLink to={Paths.handbooks.animalbreedfarmtypes}>
									{t('titles.types_of_farms')}
								</MenuLink>
							),
							title: t('titles.types_of_farms'),
						},
						{
							key: Paths.handbooks.generalProductCategory,
							icon: <CaretRightOutlined />,
							label: (
								<MenuLink to={Paths.handbooks.generalProductCategory}>
									{t('Основные типы продуктов')}
								</MenuLink>
							),
							title: t('Основные типы продуктов'),
						},
						{
							key: Paths.handbooks.typeanimal,
							icon: <CaretRightOutlined />,
							label: (
								<MenuLink to={Paths.handbooks.typeanimal}>{t('titles.animal_species')}</MenuLink>
							),
							title: t('titles.animal_species'),
						},
						{
							key: Paths.handbooks.typeproduct,
							icon: <CaretRightOutlined />,
							label: (
								<MenuLink to={Paths.handbooks.typeproduct}>{t('titles.type_product')}</MenuLink>
							),
							title: t('titles.type_product'),
						},
						{
							key: Paths.handbooks.animalbreed,
							icon: <CaretRightOutlined />,
							label: (
								<MenuLink to={Paths.handbooks.animalbreed}>{t('titles.animal_breeds')}</MenuLink>
							),
							title: t('titles.animal_breeds'),
						},
						{
							key: Paths.handbooks.direction,
							icon: <CaretRightOutlined />,
							label: <MenuLink to={Paths.handbooks.direction}>{t('titles.direction')}</MenuLink>,
							title: t('titles.direction'),
						},
					],
				},
				{
					key: Paths.handbooks.coate,
					icon: <UnorderedListOutlined />,
					label: <>{t('titles.coate')}</>,
					children: [
						{
							key: Paths.handbooks.territorialunits,
							icon: <CaretRightOutlined />,
							label: (
								<MenuLink to={Paths.handbooks.territorialunits}>
									{t('titles.territorial_units')}
								</MenuLink>
							),
							title: t('titles.territorial_units'),
						},
					],
				},
				{
					key: Paths.handbooks.organizationelements,
					icon: <UnorderedListOutlined />,
					label: <>{t('titles.organization_elements')}</>,
					children: [
						{
							key: Paths.handbooks.positions,
							icon: <CaretRightOutlined />,
							label: <MenuLink to={Paths.handbooks.positions}>{t('titles.positions')}</MenuLink>,
							title: t('titles.positions'),
						},
						{
							key: Paths.handbooks.departments,
							icon: <CaretRightOutlined />,
							label: (
								<MenuLink to={Paths.handbooks.departments}>{t('titles.departments')}</MenuLink>
							),
							title: t('titles.departments'),
						},
						{
							key: Paths.handbooks.governments,
							icon: <CaretRightOutlined />,
							label: (
								<MenuLink to={Paths.handbooks.governments}>{t('titles.governments')}</MenuLink>
							),
							title: t('titles.governments'),
						},
					],
				},
				{
					key: Paths.handbooks.realty,
					icon: <UnorderedListOutlined />,
					label: <>{t('titles.realty')}</>,
					children: [
						{
							key: Paths.handbooks.ownershiptypes,
							icon: <CaretRightOutlined />,
							label: (
								<MenuLink to={Paths.handbooks.ownershiptypes}>
									{t('titles.type_of_ownership')}
								</MenuLink>
							),
							title: t('titles.type_of_ownership'),
						},
						{
							key: Paths.handbooks.ownershipforms,
							icon: <CaretRightOutlined />,
							label: (
								<MenuLink to={Paths.handbooks.ownershipforms}>
									{t('mts.forms_of_ownership')}
								</MenuLink>
							),
							title: t('mts.forms_of_ownership'),
						},
						{
							key: Paths.handbooks.realestatelangcategories,
							icon: <CaretRightOutlined />,
							label: (
								<MenuLink to={Paths.handbooks.realestatelangcategories}>
									{t('titles.real_estate_categories')}
								</MenuLink>
							),
							title: t('titles.real_estate_categories'),
						},
						{
							key: Paths.handbooks.typeestatepurposeobject,
							icon: <CaretRightOutlined />,
							label: (
								<MenuLink to={Paths.handbooks.typeestatepurposeobject}>
									{t('titles.estate_purpose_object')}
								</MenuLink>
							),
							title: t('titles.estate_purpose_object'),
						},
						{
							key: Paths.handbooks.typeobject,
							icon: <CaretRightOutlined />,
							label: (
								<MenuLink to={Paths.handbooks.typeobject}>{t('titles.type_objects')}</MenuLink>
							),
							title: t('titles.type_objects'),
						},
						{
							key: Paths.handbooks.realestateconditions,
							icon: <CaretRightOutlined />,
							label: (
								<MenuLink to={Paths.handbooks.realestateconditions}>
									{t('titles.real_estate_conditions')}
								</MenuLink>
							),
							title: t('titles.real_estate_conditions'),
						},
					],
				},
				{
					key: Paths.handbooks.parameters,
					icon: <UnorderedListOutlined />,
					label: <>{t('titles.parameters')}</>,
					children: [
						{
							key: Paths.handbooks.unitmeasurement,
							icon: <CaretRightOutlined />,
							label: (
								<MenuLink to={Paths.handbooks.unitmeasurement}>
									{t('titles.units_of_measurement')}
								</MenuLink>
							),
							title: t('titles.units_of_measurement'),
						},
					],
				},
				{
					key: Paths.handbooks.chemicalization,
					icon: <UnorderedListOutlined />,
					label: <>{t('titles.chemicalization')}</>,
					children: [
						{
							key: Paths.handbooks.filter_fertilizer_category,
							icon: <CaretRightOutlined />,
							label: (
								<MenuLink to={Paths.handbooks.filter_fertilizer_category}>
									{t('titles.fertilizer_category')}
								</MenuLink>
							),
							title: t('titles.fertilizer_category'),
						},
						{
							key: Paths.handbooks.types_of_fertilizers,
							icon: <CaretRightOutlined />,
							label: (
								<MenuLink to={Paths.handbooks.types_of_fertilizers}>
									{t('titles.types_of_fertilizers')}
								</MenuLink>
							),
							title: t('titles.types_of_fertilizers'),
						},
						{
							key: Paths.handbooks.typesOfPesticides,
							icon: <CaretRightOutlined />,
							label: (
								<MenuLink to={Paths.handbooks.typesOfPesticides}>
									{t('titles.types_of_pesticides')}
								</MenuLink>
							),
							title: t('titles.types_of_pesticides'),
						},
						{
							key: Paths.handbooks.typesOfAgriculturalCrops,
							icon: <CaretRightOutlined />,
							label: (
								<MenuLink to={Paths.handbooks.typesOfAgriculturalCrops}>
									{t('titles.crop_type')}
								</MenuLink>
							),
							title: t('titles.crop_type'),
						},
						{
							key: Paths.handbooks.typeOfCategoryProduct,
							icon: <CaretRightOutlined />,
							label: (
								<MenuLink to={Paths.handbooks.typeOfCategoryProduct}>
									{t('titles.types_of_products')}
								</MenuLink>
							),
							title: t('titles.types_of_products'),
						},
						{
							key: Paths.handbooks.typeOfProduct,
							icon: <CaretRightOutlined />,
							label: <MenuLink to={Paths.handbooks.typeOfProduct}>{t('titles.products')}</MenuLink>,
							title: t('titles.products'),
						},
					],
				},
				{
					key: Paths.handbooks.veterinary,
					icon: <UnorderedListOutlined />,
					label: <>{t('titles.veterinary')}</>,
					children: [
						{
							key: Paths.handbooks.typeOfVeterinaryCategoryProduct,
							icon: <CaretRightOutlined />,
							label: (
								<MenuLink to={Paths.handbooks.typeOfVeterinaryCategoryProduct}>
									{t('titles.types_of_products')}
								</MenuLink>
							),
							title: t('titles.types_of_products'),
						},
						{
							key: Paths.handbooks.typeOfVeterinaryProduct,
							icon: <CaretRightOutlined />,
							label: (
								<MenuLink to={Paths.handbooks.typeOfVeterinaryProduct}>
									{t('titles.products')}
								</MenuLink>
							),
							title: t('titles.products'),
						},
					],
				},
				{
					key: Paths.handbooks.certificate,
					icon: <CaretRightOutlined />,
					label: (
						<MenuLink to={Paths.handbooks.certificate}>
							{t('Сертификаты')}
						</MenuLink>
					),
					title: t('Сертификаты'),
				},
				{
					key: Paths.handbooks.checkpoint,
					icon: <CaretRightOutlined />,
					label: (
						<MenuLink to={Paths.handbooks.checkpoint}>
							{t('КПП')}
						</MenuLink>
					),
					title: t('КПП'),
				},
				{
					key: Paths.handbooks.industryType,
					icon: <CaretRightOutlined />,
					label: (
						<MenuLink to={Paths.handbooks.industryType}>
							{t('Тип отрасли')}
						</MenuLink>
					),
					title: t('Тип отрасли'),
				},
				{
					key: Paths.handbooks.legalForm,
					icon: <CaretRightOutlined />,
					label: (
						<MenuLink to={Paths.handbooks.legalForm}>
							{t('Юридические формы')}
						</MenuLink>
					),
					title: t('Юридические формы'),
				},
				{
					key: Paths.handbooks.registerStatus,
					icon: <CaretRightOutlined />,
					label: (
						<MenuLink to={Paths.handbooks.registerStatus}>
							{t('Статусы реестров')}
						</MenuLink>
					),
					title: t('Статусы реестров'),
				},
				{
					key: Paths.handbooks.seasonality,
					icon: <CaretRightOutlined />,
					label: (
						<MenuLink to={Paths.handbooks.seasonality}>
							{t('Сезонность')}
						</MenuLink>
					),
					title: t('Сезонность'),
				},
				{
					key: Paths.handbooks.farmCategory,
					icon: <CaretRightOutlined />,
					label: (
						<MenuLink to={Paths.handbooks.farmCategory}>
							{t('Категории хозяйства')}
						</MenuLink>
					),
					title: t('Категории хозяйства'),
				},
				{
					key: Paths.handbooks.rawMaterial,
					icon: <CaretRightOutlined />,
					label: (
						<MenuLink to={Paths.handbooks.rawMaterial}>
							{t('Сырье')}
						</MenuLink>
					),
					title: t('Сырье'),
				},
				{
					key: Paths.handbooks.productionMethods,
					icon: <CaretRightOutlined />,
					label: (
						<MenuLink to={Paths.handbooks.productionMethods}>
							{t('Методы производства')}
						</MenuLink>
					),
					title: t('Методы производства'),
				},
				{
					key: Paths.handbooks.storageTypes,
					icon: <CaretRightOutlined />,
					label: (
						<MenuLink to={Paths.handbooks.storageTypes}>
							{t('Типы хранилищ')}
						</MenuLink>
					),
					title: t('Типы хранилищ'),
				},
				{
					key: Paths.handbooks.serviceType,
					icon: <CaretRightOutlined />,
					label: (
						<MenuLink to={Paths.handbooks.serviceType}>
							{t('Услуги')}
						</MenuLink>
					),
					title: t('Услуги'),
				},
				{
					key: Paths.handbooks.transportAccess,
					icon: <CaretRightOutlined />,
					label: (
						<MenuLink to={Paths.handbooks.transportAccess}>
							{t('Транспортные доступности')}
						</MenuLink>
					),
					title: t('Транспортные доступности'),
				},

			],
		},
	]

	const filterMenuItems = (items: MenuItem[], availableRoutes: any[]): MenuItem[] => {
		const userHasFullAccess = availableRoutes.some(route => route.alias === '/interactive-map-ws')

		if (userHasFullAccess) {
			return items
		}

		const filteredItems = items.map(item => {
			if (Array.isArray(item.children) && item.children.length > 0) {
				const filteredChildren = filterMenuItems(item.children, availableRoutes)

				if (filteredChildren.length > 0) {
					return { ...item, children: filteredChildren }
				}
				return null
			}

			if (
				item.key === Paths.home ||
				item.key === Paths.mechanization.info
				// item.key === 'general'
			) {
				return item
			}

			const routeData = availableRoutes.find(route => route.alias === item.key)
			return routeData && routeData.methodGet ? item : null
		})

		return filteredItems.filter(Boolean) as MenuItem[]
	}

	const filteredMenuItems = filterMenuItems(menuItems, storedData || [])

	return (
		<Sider
			className='adminsidebar'
			trigger={null}
			width={220}
			collapsible
			collapsed={collapsed}
			style={{
				overflow: 'auto',
				height: '100vh',
				position: 'fixed',
				insetInlineStart: 0,
				top: 0,
				bottom: 0,
				scrollbarWidth: 'thin',
				scrollbarColor: 'unset',
				background: '#ffffff',
			}}
		>
			{' '}
			<Link to='/'>
				<Logo>
					{collapsed ? (
						<img style={{ width: '54px' }} src='../../../logocircle.svg' alt='' />
					) : (
						<img style={{ width: '95%' }} src='../../../logoadmin.svg' alt='' />
					)}
				</Logo>
			</Link>
			<Menu
				theme='light'
				mode='inline'
				selectedKeys={getSelectedKeys()}
				defaultOpenKeys={getDefaultOpenKeys()}
				items={filteredMenuItems}
			/>
		</Sider>
	)
}
